<div class="shimmer-wrapper">
  <div class="shimmer">
    <div class="container"></div>
  </div>
</div>
